import { useGetRoomSessionsForFilterQuery, useGetUserRoomSessionsQuery } from '../../../apps/professional-app/fa/store/fa'
import { FilterAttribute, FilterOperator, OperatorType, type SessionFilter } from '../../../components/SessionFilters/model'
import { selectAccountId } from '../../../store/auth/authSlice'
import { useAppSelector } from '../../../store/hooks'
import { DEFAULT_URL_PAGE_SIZE, type UrlPagination, useUrlPagination } from './useUrlPagination'

interface ContactMeetingsQueryOptions {
  totalOnly?: boolean
}

const FIRST_PAGE_REQUEST = { page: 0, size: DEFAULT_URL_PAGE_SIZE }

const toPageRequest = ({ pageRequest }: UrlPagination, { totalOnly }: ContactMeetingsQueryOptions) => (totalOnly ? FIRST_PAGE_REQUEST : pageRequest)

const isFirstPageRequest = ({ page, pageSize }: UrlPagination) => page === 1 && pageSize === DEFAULT_URL_PAGE_SIZE

export const useContactPastMeetings = (contactId: string, options: ContactMeetingsQueryOptions = {}) => {
  const accountId = useAppSelector(selectAccountId)
  const pagination = useUrlPagination('page', 'pageSize')
  const query = useGetUserRoomSessionsQuery(
    {
      accountId,
      participantId: contactId,
      pageRequest: toPageRequest(pagination, options),
    },
    { skip: !contactId, refetchOnMountOrArgChange: options.totalOnly || !isFirstPageRequest(pagination) },
  )
  return { ...query, pagination }
}

const buildContactUpcomingFilter = (contactId: string): SessionFilter => ({
  type: 'composite',
  operator: OperatorType.AND,
  filters: [
    { type: 'individual', filter: { op: FilterOperator.IN, attr: FilterAttribute.CONTACT_ID, val: contactId } },
    // Must match selectUpcomingMeetingsCompositeFilter in sessionFilter.ts.
    { type: 'individual', filter: { op: FilterOperator.GT, attr: FilterAttribute.STARTED, val: '{now+5m}' } },
  ],
})

export const useContactUpcomingMeetings = (contactId: string, options: ContactMeetingsQueryOptions = {}) => {
  const accountId = useAppSelector(selectAccountId)
  const pagination = useUrlPagination('upcomingPage', 'upcomingPageSize')
  const query = useGetRoomSessionsForFilterQuery(
    {
      accountId,
      filter: buildContactUpcomingFilter(contactId),
      sort: { attr: FilterAttribute.STARTED, dir: 'asc' },
      pageRequest: toPageRequest(pagination, options),
    },
    { skip: !contactId, refetchOnMountOrArgChange: options.totalOnly || !isFirstPageRequest(pagination) },
  )
  return { ...query, pagination }
}
